const INDICATOR_SIZE = 15;

export default (theme) => ({
    '@keyframes cylonSweep': {
        '0%, 100%': { backgroundPosition: '150% center' },
        '50%': { backgroundPosition: '-50% center' },
    },
    root: {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        textAlign: 'left',
    },
    item: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
    },
    indicator: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: INDICATOR_SIZE,
        height: INDICATOR_SIZE,
        flexShrink: 0,
        boxSizing: 'border-box',
    },
    indicatorActive: {
        borderRadius: '50%',
        '& > div': {
            width: INDICATOR_SIZE,
            height: INDICATOR_SIZE,
            borderWidth: 2,
            marginBottom: 0,
        },
    },
    checkIcon: {
        width: 10,
        height: 10,
        '& svg': {
            width: 10,
            height: 10,
        },
    },
    indicatorCompleted: {
        borderRadius: '50%',
        backgroundColor: theme.colors.semantic.positive500,
    },
    indicatorPending: {
        borderRadius: '50%',
        border: `1.5px solid ${theme.colors.grey[100]}`,
        backgroundColor: theme.colors.primary.white,
    },
    activeLabelSweep: {
        ...theme.typography.body,
        background: `linear-gradient(90deg, ${theme.colors.utility.textPrimary} 35%, ${theme.colors.primary.white} 50%, ${theme.colors.utility.textPrimary} 65%)`,
        backgroundClip: 'text',
        backgroundSize: '200% 100%',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        animation: '$cylonSweep 2.5s ease-in-out infinite',
        color: 'transparent',
    },
});
